import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.reduce.js";
function n(r, ...i) {
  return i.reduce((t, o) => t.concat((o || "").split(" ")), []).map((t) => r[t]).filter((t) => t).join(" ");
}
export {
  n as default
};
